/**
 * URL for connector-instance parameters with server-side decryption of all
 * master-flagged sensitive fields (AES-GCM). Use only for authenticated connect flows.
 */
export function buildConnectorParametersDecryptUrl(connectorInstanceId) {
  const base = process.env.REACT_APP_BACKEND_URL || '';
  return `${base}synctrack/sync-connector-parameters/connector/${connectorInstanceId}?decryptSensitiveValues=true`;
}
